import { Box, CircularProgress } from "@mui/material";
import { CircularProgressWithLabel } from "./CircularProgressLoading";

const CircularLoading = ({
  height = "100%",
  percents,
}: {
  height?: string;
  percents?: number;
}) => {
  const loader = percents ? (
    <CircularProgressWithLabel value={percents} />
  ) : (
    <CircularProgress />
  );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height,
      }}
    >
      {loader}
    </Box>
  );
};

export default CircularLoading;
